<template>
  <div>
    <v-container fluid>
      <dashboard-admin v-if="role === 'super-admin'"></dashboard-admin>
      <dashboard-provider v-if="role === 'provider'"></dashboard-provider>
      <DashboardRepresentative
        v-if="role === 'institution-representative'"
      ></DashboardRepresentative>
    </v-container>
  </div>
</template>

<script>
import DashboardAdmin from '@/components/dashboard/DashboardAdmin';
import DashboardProvider from '@/components/dashboard/DashboardProvider';
import DashboardRepresentative from '@/components/dashboard/DashboardRepresentative.vue';

export default {
  name: 'DashboardPage',
  components: {
    DashboardProvider,
    DashboardAdmin,
    DashboardRepresentative,
  },
  computed: {
    role() {
      return this.$store.getters.roles;
    },
  },
};
</script>
